import { InjectionToken } from '@angular/core';

export interface Appcues {
  anonymous: () => void;
  identify: (id: string, data: any) => void;
  page: () => void;
  start: () => void;
  track(event: string, value?: any): void;
}

export interface IFBWindow extends Window {
  Appcues: Appcues;
  Firstbird?: IFBWindowNamespace;
  _jipt: string[][];
  _paq: string[][];
  handleOpenURL: (url: string) => NodeJS.Timeout;
  dataLayer: object[];
}

export interface IFBWindowNamespace {
  // This is a trick to allow app to boot without hash params,
  // which are interfering with angular html5 mode (uri /#access_token... is tried to be matched against a route).
  // Before app bootstrap a full url will be written to this variable and then hash part will be cleaned from url,
  // after that when app bootstraps it will pick up params again from this variable.
  originalHref?: string;
  redirectPath?: string;
  redirectState?: string;
}

export const IFBWindow = new InjectionToken<IFBWindow>('An abstraction over global window object', {
  factory: () => window as unknown as IFBWindow
});
